var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg",attrs:{"elevation":"2","dark":"","color":_vm.styleCicle}},[_c('v-card-text',{staticClass:"d-flex justify-space-between align-center"},[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.cardTitle))])]),_c('span',{staticClass:"text-h3 font-weight-medium"},[_vm._v(_vm._s(_vm.result))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }